import { DataTypeProvider } from "@devexpress/dx-react-grid"
import { Chip } from "@mui/material"
import React from "react"
import { Link } from "react-router-dom"
import TimeAgo from 'react-timeago'

// ************************************************************

const DateFormatter = ({ value }) => {
  if (value === "0000-00-00 00:00:00")
    return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const RowNumFormatter = ({ row }) => {
  return <Chip label={row.row_num} size="small" variant="outlined" />  
}
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

export const UnlockerUsernameFormatter = ({ row }) => {
  return <Link to={"/service/user/details/" + row.unlocker_id}>{row.unlocker_username}</Link>
}
export const TimeLimitFormatter = ({ row }) => {
  if (row.base_code.length == 10) {
    // omegas
    return (
      <b style={{ color: 'darkred' }}>    
        {row.time_limit} days
      </b>
    )
  } else if (row.time_limit == 0) {
    // plus max - no limit
    return (
      <b style={{ color: 'black' }}>    
        <em>no limit</em>
      </b>
    )
  } else {
    // plus max
    return (
      <b style={{ color: 'darkgreen' }}>    
        {row.time_limit} months
      </b>
    )
  }
}

// ************************************************************

export default class ServiceUnlockCodeListTableProps {
  getTableColumns() {
    return [
      { name: 'row_num',            title: '#',                   getCellValue: row => row.row_num },
      { name: 'id',                 title: 'Id',                  getCellValue: row => row.id },
      { name: 'first_name',         title: 'First Name',          getCellValue: row => row.first_name },
      { name: 'last_name',          title: 'Last Name',           getCellValue: row => row.last_name },
      { name: 'company_name',       title: 'Company Name',        getCellValue: row => row.company_name },
      { name: 'company_country',    title: 'Company Country',     getCellValue: row => row.company_country },
      { name: 'phone',              title: 'Phone',               getCellValue: row => row.phone },
      { name: 'created_at',         title: 'Created at',          getCellValue: row => row.created_at },
      { name: 'base_code',          title: 'Base Code',           getCellValue: row => row.base_code },
      { name: 'unlock_code',        title: 'Unlock Code',         getCellValue: row => row.unlock_code },
      { name: 'time_limit',         title: 'Time Limit',          getCellValue: row => row.time_limit },
      { name: 'unlocker_username',  title: 'Unlocker',            getCellValue: row => row.unlocker_username },
    ]
  }
  getTableColumnWidths() {
    return [
      { columnName: 'row_num',            width: 100 },
      { columnName: 'id',                 width:   0 },
      { columnName: 'first_name',         width: 100 },
      { columnName: 'last_name',          width: 100 },
      { columnName: 'company_name',       width: 140 },
      { columnName: 'company_country',    width: 140 },
      { columnName: 'phone',              width: 120 },
      { columnName: 'created_at',         width: 120 },
      { columnName: 'base_code',          width: 140 },
      { columnName: 'unlock_code',        width: 140 },
      { columnName: 'time_limit',         width: 140 },
      { columnName: 'unlocker_username',  width: 140 },
    ]
  }
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num',            align: 'right' },
      { columnName: 'id',                 align: 'right' },
      { columnName: 'created_at',         align: 'right' },
      { columnName: 'base_code',          align: 'right' },
      { columnName: 'unlock_code',        align: 'right' },
      { columnName: 'time_limit',         align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',            sortingEnabled: false },
      { columnName: 'phone',              sortingEnabled: false },
      { columnName: 'time_limit',         sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',            filteringEnabled: false },
      { columnName: 'id',                 filteringEnabled: false },
      { columnName: 'created_at',         filteringEnabled: false },
      { columnName: 'time_limit',         filteringEnabled: false },
    ]
  }
}
